export default "__VITE_ASSET__COrgTH2H__"